// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"746":"a16fcda1","810":"811623b5","960":"cd16177f"}[chunkId] + ".js";
};